import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PackingMachineTypePipe } from '../../models/entities/packing-machine-type-pipe';
import { PackingOrder } from '../../models/entities/packing-order';
import { PackingOrderStep } from '../../models/entities/packing-order-step';
import { PackingOrderService } from '../../services/packing-order.service';

@Component({
  selector: 'packing-order-steps',
  templateUrl: './packing-order-steps.component.html',
  styleUrls: ['./packing-order-steps.component.scss']
})
export class PackingOrderStepsComponent implements OnInit {


  @Input() packingOrder : PackingOrder;
  constructor(
    protected packingOrderService  : PackingOrderService,
    protected leanUtilsService     : LeanUtilsService,
    protected toastr               : ToastrService
  ) { }

  currentIndex            : number = null;
  packCode                : string = "";
  packingMachineTypePipe  : PackingMachineTypePipe;
  editMode                : string = 'R';

  ngOnInit() {
  }

//----------------------------------------------------------------------
  processPack(packingOrderStep : PackingOrderStep){
    if (this.packCode.trim() == "") {
      this.toastr.error("Prière de saisir le code de la palette");
      return;
    }
    if ( (packingOrderStep.packingMachine.packingMachineType.packingMachineTypePipes.length)
      && ( ! this.packingMachineTypePipe)){
        this.toastr.error("Prière de saisir la ligne de sortie machine");
        return;
    }
    this.editMode = 'R';

    let packingMachineTypePipeId = null;
    if (this.packingMachineTypePipe) packingMachineTypePipeId = this.packingMachineTypePipe.id
    
    this.packingOrderService.movePackToPackingOrderStep(packingOrderStep, this.packCode, packingMachineTypePipeId).then(result => {
        packingOrderStep.quantity = result;
        this.packCode = null;
    })
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
  selectStep(packingOrderStep : PackingOrderStep){
    if (  this.currentIndex == this.packingOrder.packingOrderSteps.indexOf(packingOrderStep)){
      this.currentIndex = null;
      this.editMode = 'R';
      return;
    }
    this.currentIndex = this.packingOrder.packingOrderSteps.indexOf(packingOrderStep);
    this.editMode = 'U';
    this.packingMachineTypePipe = null;
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
  getPreviousStepQuantity(packingOrderStep : PackingOrderStep) : number{
    let index = this.packingOrder.packingOrderSteps.indexOf(packingOrderStep);
    if (index == 0) return 0;
    let packingOrderStepPrevious : PackingOrderStep = this.packingOrder.packingOrderSteps[index-1];
    return packingOrderStepPrevious.quantity;
  }
  getStepLocalRate(packingOrderStep : PackingOrderStep) : number{
    let previousStepQuantity = this.getPreviousStepQuantity(packingOrderStep);
    if (! previousStepQuantity) return 0;
    return  this.leanUtilsService.round(packingOrderStep.quantity * 100 /  previousStepQuantity, 0); 
  }

  getStepGlobalRate(packingOrderStep : PackingOrderStep) : number{
      if (! this.packingOrder.quantity) return 0;
      return this.leanUtilsService.round(packingOrderStep.quantity * 100 / this.packingOrder.quantity, 0);
  }
//----------------------------------------------------------------------


}
